import React from 'react';
import { Box } from '@mui/material';

export const PageContainer = ({ children, sx, ...props }) => (
    <Box
        sx={{
            width: { xs: "100%", md: "96%" },
            px: { xs: "0.65rem", md: 0 },
            mx: "auto",
            boxSizing: "border-box",
            minWidth: 0,
            ...sx,
        }}
        {...props}
    >
        {children}
    </Box>
);